/* Bhairav Tatva: Shopify's own "Buy it now" button reads "Buy now", matching the sticky bar and the gemstone pages.
   The button is drawn by Shopify's checkout script, so its text is changed after it appears. */
(() => {
  let queued = false;
  const fix = () => {
    queued = false;
    document.querySelectorAll('.shopify-payment-button__button--unbranded').forEach((b) => {
      if (/^\s*buy it now\s*$/i.test(b.textContent)) b.textContent = 'Buy now';
    });
  };
  const queue = () => { if (!queued) { queued = true; requestAnimationFrame(fix); } };
  fix();
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
})();
